<template>
  <div class="p-search-suggest-wrap">
    <div class="p-search-suggest-list" v-loading="isLoading">
      <template v-if="isHasData">

        <div class="p-search-suggest_all" name="全文搜索" @click="goSearchDetail()">
          <em class="ibass ibass-search"></em>
          <span :title="searchVal">在全文中搜索“{{searchVal}}”</span>
        </div>

        <template v-for="(list, index) in lawSearchSuggestList" name="快速前往">
          <ul :key="index" v-if="index === 0">
            <li v-if="list.value.length > 0">快速前往</li>
            <li v-for="(item, i) in list.value" :key="i" @click="goSearchDetail(list, item)">
              <em class="ibass ibass-arrow-next"></em>
              <span :title="item.name || item">{{item.name || item}}</span>
            </li>
          </ul>
        </template>

      </template>
    </div>
  </div>
</template>
<script>
import { debounce } from 'lodash'
import indexService from '../../../service/index'
export default {
  name: 'PSearchSuggestLaw',
  props: {
    searchVal: {
      type: String,
      default: () => ''
    },
    currentType: {
      type: String,
      default: () => 'case'
    }
  },
  computed: {
    // 判断联想数据标题中是不是都有值（只显示标题）
    isHasData () {
      let isHasData = true
      if (this.lawSearchSuggestList.length === 0 || this.lawSearchSuggestList[0].name !== 'title' || this.lawSearchSuggestList[0].value.length === 0) {
        isHasData = false
      } else {
        isHasData = true
      }
      return isHasData
    }
  },
  watch: {
    searchVal: debounce(function (value) {
      if (value.trim()) {
        this.getSearchAssociate(value.trim())
      }
    }, 500),
    isHasData: function (value) {
      this.$emit('isShowSearchSuggest', value)
    }
  },
  data () {
    return {
      isLoading: false,
      lawSearchSuggestList: [] // 法规搜索联想数据
    }
  },
  mounted () {
    if (this.searchVal.trim()) {
      this.getSearchAssociate(this.searchVal)
    }
  },
  methods: {
    async getSearchAssociate (value) {
      this.isLoading = true
      let response = null
      let val = value.trim()
      response = await indexService.getLawSearchSeggestList(val)
      if (response.succeed || response.isSuccess) {
        this.isLoading = false
        this.lawSearchSuggestList = response.result || response.data || []
        // -------- 判断是否有有效数据start ---------
        let flag = true
        if (this.lawSearchSuggestList.length === 0 || this.lawSearchSuggestList[0].name !== 'title' || this.lawSearchSuggestList[0].value.length === 0) {
          flag = false
        } else {
          flag = true
        }
        // -------- 判断是否有有效数据end ---------

        // 没有数据则发送消息
        if (!flag) {
          this.$emit('isShowSearchSuggest', false)
        }
      } else {
        this.isLoading = false
        this.$emit('isShowSearchSuggest', false)
        this.$postMessage.toast({ msg: response.message || response.resultMsg })
      }
    },
    goSearchDetail (data, item) {
      data = data || { directToPageFlag: true, directToList: true, name: '', pre: '全文', nameDescription: '全文包含', value: [ { name: this.searchVal.trim() } ] }
      item = item || { name: this.searchVal.trim() }
      window.localStorage.setItem('fromWorkFlatSuggestData', JSON.stringify(data))
      // 通知dataBaseSearch.vue组件
      this.$emit('searchSuggestItemClickCallBack')
      // 给工作台页面发送消息，其他跳转操作交给接口消息者
      window.parent.postMessage({
        action: 'fromWorkFlatSuggestSearchLaw',
        data: { keyword: this.searchVal.trim(), query: JSON.stringify(item), currentType: this.currentType }
      }, process.env.VUE_APP_IFRAME_DOMAIN)
    }
  }
}
</script>
<style lang="stylus" scoped>
.p-search-suggest-wrap
  width 90%
  margin -1px auto 0
  position relative
  z-index 9
  .p-search-suggest-list
    min-height 36px
    max-height 400px
    padding 15px 0
    overflow auto
    border-radius 10px
    box-shadow 0 4px 9px 0 rgba(0, 0, 0, 0.1)
    border 1px solid #e5e5e5
    background #fff
    z-index 11
    .p-search-suggest_all
      padding 0 10px
      line-height 36px
      overflow hidden
      text-overflow ellipsis
      white-space nowrap
      cursor pointer
      border-bottom 1px solid #f0f0f0
      &:hover
        background-color #f8f8f9
      em
        position relative
        top 2px
        margin-right 10px
        color #cdc9c5
        font-size 16px

    ul
      li
        padding 0 10px
        line-height 36px
        overflow hidden
        text-overflow ellipsis
        white-space nowrap
        &:first-child
          margin-left 26px
          font-weight 700
          color #4a4a4a
        &:not(:first-child)
          cursor pointer
        &:not(:first-child):hover
          background-color #f8f8f9
        &.none-data
          text-align center
        em
          position relative
          top 2px
          margin-right 10px
          color #cdc9c5
          font-size 16px
</style>
